import { MoveHorizontal } from "lucide-react";
import { iconSizes } from "./constants";
import {cn} from "@gettactic/helpers";

interface DragHandleProps {
  isDragging: boolean;
  onMouseDown: (e: React.MouseEvent) => void;
  size?: keyof typeof iconSizes;
}

const sizeClasses = {
  sm: "left-1.5",
  default: "left-2",
  lg: "left-3",
  xl: "left-4",
};

export function DragHandle({
  isDragging,
  onMouseDown,
  size = "default",
}: DragHandleProps) {
  return (
    <div
      className={cn(
        "absolute top-1/2 -translate-y-1/2 cursor-ew-resize p-1",
        "text-muted-foreground hover:text-foreground",
        isDragging && "text-foreground",
        sizeClasses[size],
      )}
      onMouseDown={onMouseDown}
    >
      <MoveHorizontal className={iconSizes[size]} />
    </div>
  );
}
